// @flow

import { graphql } from 'react-relay';
import { PageMeta } from '../shared/prismic/PageMeta';
import { type NextQuery, nextQuery } from '../controls/relay';
import { MuiThemeProvider } from '../controls/mui-providers';
import { Layout } from '../shared/Layout';
import { Development } from '../shared/DevelopmentDetails/Development';

import type { developmentQuery } from './__generated__/developmentQuery.graphql';

const DevelopmentPage = ({ data }) => {
  return (
    <Layout
      root={data}
      headerStyle="normal"
      pageWithData={data.cms.pageWithData}
      customCountrySwitcherHref={{ pathname: '/', query: {} }}
    >
      <MuiThemeProvider>
        <PageMeta
          root={data}
          data={{
            developmentTitle: data.developmentProductBySlug?.title ?? '',
          }}
        />
        {data.developmentProductBySlug && (
          <Development development={data.developmentProductBySlug} />
        )}
      </MuiThemeProvider>
    </Layout>
  );
};

const DevelopmentP: NextQuery<
  developmentQuery,
  {| slug: string, lang?: string, uid?: string |},
> = nextQuery(ctx => ({
  query: graphql`
    query developmentQuery($slug: String!, $uid: String!, $lang: String!) {
      ...Layout_root @arguments(lang: $lang)
      ...PageMeta_root

      developmentProductBySlug(slug: $slug) {
        ...Development_development
        title
      }
      cms {
        pageWithData(uid: $uid, lang: $lang) {
          ...Layout_pageWithData
        }
      }
    }
  `,
  variables: {
    slug: ctx.query.slug,
    uid: ctx.query.uid ?? '',
    lang: ctx.query.lang ?? '',
  },
  cacheStrategy: 'cache-first',
  validate: data => {
    if (data.developmentProductBySlug == null) {
      return { type: 'error', statusCode: 404 };
    }

    return null;
  },
}))(DevelopmentPage);

export default DevelopmentP;
